import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;

  img {
    margin-right: 1rem;
    border-radius: 50%;
  }

  p {
    color: ${(props) => props.theme.gray5};
    font-weight: 600;
  }
`;
